import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { DAYS_PER_MONTH_CONSTANT } from '@core/configs';

import { ProductType } from '@core/model/enums';

@Injectable({ providedIn: 'root' })
export class SimulatorService {
  private readonly baseUrl: string;
  private readonly headers: { [key: string]: string };

  constructor(private readonly http: HttpClient) {
    this.baseUrl = `${environment.apiGatewayUrl}back-simulator-management/v1/simulator`;
    this.headers = { 'Content-Language': 'es-CO' };
  }

  public quotasValue({ amount, term }: { amount: number; term: number }): Observable<number> {
    return this.getSimulationConfig().pipe(
      switchMap((response: Array<{ productConditionId: string }>) => {
        const conditionId = response[0].productConditionId;
        return this.getSimulationResults(conditionId, amount, term).pipe(
          map((fees: Array<{ value: number }>) => this.calculateTotal(fees))
        );
      })
    );
  }

  private getSimulationConfig(): Observable<Array<{ productConditionId: string }>> {
    const url = `${this.baseUrl}/config?productCode=RP`;
    return this.http.get<Array<{ productConditionId: string }>>(url, { headers: this.headers });
  }

  private getSimulationResults(
    conditionId: string,
    amount: number,
    term: number
  ): Observable<Array<{ value: number }>> {
    const url = `${this.baseUrl}/simulate?conditionId=${conditionId}&amount=${amount}&term=${
      term * DAYS_PER_MONTH_CONSTANT
    }`;
    return this.http.get<Array<{ value: number }>>(url, { headers: this.headers });
  }

  private calculateTotal(fees: Array<{ value: number }>): number {
    return fees.reduce((acc, item) => acc + item.value, 0);
  }
}
